import { Button } from "@ravalmatic/catafractum-utils";
import { ContractPresentation } from "../BoardManager";
import { Declarer } from "./Declarer";
import { ContractBid } from "./ContractBid";
import { InfoContractContainer } from "./InfoContractContainer";

export class ContractContainer extends Phaser.GameObjects.Container {

    private readonly title: Phaser.GameObjects.Image;
    private readonly continueBtn: Button;
    private readonly infoButton: Button;
    private readonly infoContractContainer: InfoContractContainer;
    private readonly tricksLabel: Phaser.GameObjects.Text;
    private readonly noContractLabel: Phaser.GameObjects.Text;
    private readonly developmentLabel: Phaser.GameObjects.Text;
    private declarer?: Declarer;
    private contractBid?: ContractBid;
    private presentation?: ContractPresentation;

    constructor(scene: Phaser.Scene, onContinue: () => void, continueButtonY: number) {

        super(scene);

        this.title = new Phaser.GameObjects.Image(scene, 0, -160, "texture_atlas_1", "contract_title");
        this.tricksLabel = new Phaser.GameObjects.Text(scene, 0, 0, "", {
            color: "#ffffff",
            fontFamily: "Baloo2-Regular",
            fontSize: "32px"
        });
        this.tricksLabel.setOrigin(.5);
        this.noContractLabel = new Phaser.GameObjects.Text(scene, 0, 50, "No contract", {
            color: "#ffffff",
            fontFamily: "Baloo2-Regular",
            fontSize: "20px"
        }).setOrigin(.5);
        this.noContractLabel.setVisible(false);
        this.developmentLabel = new Phaser.GameObjects.Text(scene, 0, -100, "DEVELOPMENT CONTRACT", {
            color: "#00ffff",
            fontFamily: "Baloo2-Regular",
            fontSize: "18px"
        }).setOrigin(.5);
        this.developmentLabel.setVisible(false);
        this.continueBtn = new Button(scene, 0, continueButtonY, "texture_atlas_1", "btn_continue");
        this.continueBtn.setInflationTween(1.05);
        this.continueBtn.onUp(onContinue, this);
        this.continueBtn.disable();

        this.infoButton = new Button(scene, 0, 0, "texture_atlas_1", "btn_info_contract");
        this.infoButton.setScale(.5);
        this.infoButton.setInflationTween(1.05);
        this.infoButton.onUp(this.showContractHelp, this);
        this.infoButton.setVisible(false);
        this.infoButton.disable();
        this.infoContractContainer = new InfoContractContainer(
            scene, this.showContractDetails.bind(this), continueButtonY
        );
        this.add([
            this.title,
            this.tricksLabel,
            this.noContractLabel,
            this.developmentLabel,
            this.infoButton,
            this.infoContractContainer,
            this.continueBtn
        ]);
        this.setVisible(false);
    }

    public showContract(presentation: ContractPresentation): void {

        this.presentation = presentation;
        const contract = presentation.contract;
        this.declarer?.destroy();
        this.declarer = undefined;
        this.contractBid?.destroy();
        this.contractBid = undefined;
        if (contract !== null) {
            this.contractBid = new ContractBid(this.scene, contract);
            this.contractBid.setPosition(-104.5, -14);
            this.add(this.contractBid);
            this.declarer = new Declarer(this.scene, contract.declarer);
            this.declarer.setPosition(112.5, -14);
            this.add(this.declarer);
        }

        this.tricksLabel.setY(this.declarer ? 149 : 14);
        this.developmentLabel.setVisible(presentation.kind === "development-contract");
        const tricksToMake = contract !== null ? contract.level + 6 : null;
        this.tricksLabel.setText(tricksToMake === null ? "PASSED OUT" : `${tricksToMake} tricks to make`);
        this.infoButton.setPosition(
            this.tricksLabel.x + this.tricksLabel.displayWidth / 2 + 34,
            this.tricksLabel.y + 2
        );
        this.setContractDetailsVisible(true);
        this.setVisible(true);
        this.continueBtn.enable();
    }

    public disableContinue(): void {

        this.continueBtn.disable();
    }

    public setPlayerAvatarId(avatarId: number): void {

        this.declarer?.setPlayerAvatarId(avatarId);
    }

    private showContractHelp(): void {

        if (!this.presentation?.contract) {
            return;
        }

        this.infoContractContainer.showContract(this.presentation.contract);
        this.setContractDetailsVisible(false);
        this.continueBtn.disable();
    }

    private showContractDetails(): void {

        this.setContractDetailsVisible(true);
        this.continueBtn.enable();
    }

    private setContractDetailsVisible(visible: boolean): void {

        const presentation = this.presentation;
        if (!presentation) {
            return;
        }

        const hasContract = presentation.contract !== null;
        this.title.setVisible(visible);
        this.tricksLabel.setVisible(visible);
        this.noContractLabel.setVisible(visible && !hasContract);
        this.developmentLabel.setVisible(visible && presentation.kind === "development-contract");
        this.contractBid?.setVisible(visible);
        this.declarer?.setVisible(visible);
        this.infoButton.setVisible(visible && hasContract);
        this.continueBtn.setVisible(visible);
        if (visible && hasContract) {
            this.infoButton.enable();
        } else {
            this.infoButton.disable();
        }
        this.infoContractContainer.setVisible(!visible);
    }
}
